/* istanbul ignore next */
const styles = ({
  breakpoints,
  palette: {
    secondary: { normal }
  },
  spacing: { unit },
  typography: { fontWeightLight, fontWeightMedium }
}) => ({
  success: {},
  alertDetails: {
    display: 'flex',
    justifyContent: 'flex-start',
    fontSize: unit * 1.5,
    margin: `0 ${unit * 1.25}px`,
    [`@media only screen and (max-width: ${breakpoints.values.sm}px)`]: {
      flexDirection: 'column'
    }
  },
  alertCol: {
    display: 'flex',
    flexDirection: 'column',
    flexGrow: 1,
    padding: `0 ${unit * 2}px`,
    maxWidth: unit * 20,
    overflow: 'auto',
    [`@media only screen and (max-width: ${breakpoints.values.sm}px)`]: {
      minHeight: '50px'
    }
  },
  alertMemoCol: {
    maxWidth: unit * 40,
    wordWrap: 'break-word'
  },
  alertHead: {
    fontWeight: fontWeightMedium,
    textTransform: 'capitalize'
  },
  alertValue: {
    fontWeight: fontWeightLight
  },
  message: {
    transition: 'all  500ms',
    opacity: 1,
    transform: 'translateY(0)',
    '& .test': {
      width: '100%'
    }
  },
  messageExit: {
    transition: 'all  500ms',
    opacity: 0,
    transform: `translateY(-${unit * 3}px)`
  },
  section: {
    width: '100%'
  },
  nativeAlert: {
    padding: `${unit * 1.25}px 0px`,
    '& + &': {
      borderTop: `1px solid ${normal}`
    }
  },
  titleExtra: {
    display: 'inline-block',
    marginLeft: unit
  }
});

export default styles;
